import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourSanctuaryForRenewal from "./sections/YourSanctuaryForRenewal";
import Information from "./sections/Information";
import TheLogisticsExperts from "./sections/TheLogisticsExperts";
import EliteCoachingSolutions from "./sections/EliteCoachingSolutions";
import VoicesOfTransformation from "./sections/VoicesOfTransformation";
import JoinThePlatform from "./sections/JoinThePlatform";
import CorporateFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YourSanctuaryForRenewal />
      <Information />
      <TheLogisticsExperts />
      <EliteCoachingSolutions />
      <VoicesOfTransformation />
      <JoinThePlatform />
      <CorporateFooter />
    </div>;
}